import React, { useEffect, useState } from 'react'
import { Container, Card, Spinner, Row, Col, Modal } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import withLocation from '../../withLocation'
import { connect } from 'react-redux'
import ContactUsDialog from '../../dialog/contactUsDialog'
import CarImageSection from './carImageSection'
import CarDetailsSection from './carDetailsSection'
import NovatedLeaseSection from './novatedLeaseSection'
import DeductionSection from './deductionSection'
import TakeHomeSection from './takeHomeSection'
import RfbaSection from './rfbaSection'
import { TermsAndConditions } from '../../termsAndConditions'
import { PrimaryButton, AlertBlockComponent } from '@mmsg/louie'
import { fetchIndividualEstimate } from 'application/actions/individualEstimateActions'
import { createPdfBase64 } from 'application/utils/utilityFunctions'
import {
  startedPdfDownload,
  finishedPdfDownload,
} from 'application/actions/downloadPdfAction'
import {
  OnProposalAuthorisation,
  OnProposalAcceptance,
} from 'application/actions/proposalsActions'
import SpartaCustomerCount from '../estimate-compare/spartaCustomerCount'
import { proposalAuthorisedConstants } from 'application/constants/actionTypes'
import { useHistory } from 'react-router-dom'
import Layout from 'application/layout'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  fireInteractionCustomEvent,
  checkConsultant,
  IsSpecialEmployer,
  IsVehicleElectric,
  formatCurrency,
} from 'application/helpers'
import { MdErrorOutline } from 'react-icons/md'
import { Alert } from 'react-bootstrap'
import { SummarySheet } from '../pdf/summarySheet'
import * as E from './proposalElements'
import { ReactComponent as InfoTriangleIcon } from '../../../images/Info-triangle.svg'
import { ReactComponent as EVBolt } from '../../../images/ev-bolt.svg'
import { PdfView } from './../pdf/pdfView'
import ChecklistSection from './checklistSection'
import RioTintoFormattedData from './rioTintoFormattedData'
import NswHNFormattedData from './nswHNFormattedData'
import EstimateSummarySection from '../estimate-details/estimateSummarySection'
import { IAfterMarketAccessoriesProps, IAfterMarketAccessoryProps, ITheme } from 'application/utils/type'
import { IProposalUserEmployer } from './proposalInterfaces/userEmployerProps'
import { IProposalDeductionSectionProps } from './proposalInterfaces/deductionSectionProps'
import { IProposalNovatedLeaseSectionProps } from './proposalInterfaces/novatedLeaseSectionProps'
import { IProposalSummarySheetProps } from './proposalInterfaces/summarySheetProps'
import { IProposalEstimateProps } from './proposalInterfaces/proposalEstimateProps'
import { IProposalVehicleProps } from './proposalInterfaces/vehicleProps'
import { SubMenuBar } from '@mmsg/louie'
import zenscroll from 'zenscroll'
import { formatDate } from 'application/helpers/index'
import globals, { isBrandMX, isBrandRS } from 'application/constants/globals'
import { TermsAndConditionsRS } from 'application/components/termsAndConditionsRS'
import { Image as MaxxiaImage } from 'Maxxia/images'
import { Image as RemServImage } from 'RemServ/images'
import { Icon as RemServIcon } from 'RemServ/icons'
import BannerMainImageSection from 'application/components/bannerMainImageSection'
import SagByoFormattedData from './sagbyoFormattedData'
import { SummarySheetMX } from '../pdf/summarySheetMX'

interface IInputProps {
  isAuthenticated: boolean
  opportunityId: string
  consultantFirstName: string
  userFirstName: string
  payFrequency: string
  applicationRole: { isConsultant: boolean }
  annualRate: number
  fbtMethod: string
  leaseTerm: number
  kmPerAnnum: number
  nlFeePerPay: number
  financeAmount: number
  carRepaymentPerPayExGST: number
  totalLeaseRunningCostsPerPayExGST: number
  compInsuranceCommissionPerAnnumIncGST: number
  compInsuranceProvider: string
  gapCoverCommissionPerAnnumIncGST: number
  vehicleFBTValue: number
  financierEstablishmentFeePerAnnum: number
  rpcPremium: number
  brokeragePerAnnum: number
  residualPCT: number
  leaseResidualAmountIncGST: number
  nlFeePerAnnumIncGST: number
  financierEstablishmentFee: number
  financierFeePerPay: number
  spFeePerAnnumIncGST: number
  extendedWarrantyCommGST: number
  extendedWarrantyCommExGST: number
  extendenWarrantyCommissionPerAnnumIncGST: number
  isExGST: boolean
  leaseProtectionCommissionPerAnnumIncGST: number
  leaseProtectionCommExGST: number
  monthlyRepaymentAmountIncGST: number
  procurementFee: number
  rpcCommissionPerAnnumIncGST: number
  rpcCommissionExGST: number
  rpcCommGST: number
  retailPrice: number
  priveawayPrice: number
  theme: ITheme
  brand: string
  ctp: number
  registrationFee: number
  stampDutyViaDisbursement: number
  compInsuranceCommissionExGST: number
  compInsuranceCommGST: number
  gapCoverCommissionExGST: number
  gapCoverCommGST: number
  brokerage: number
  proposalEstimateId: number
  type: string
  evRebateApplicable: boolean
  evRebateValue: number
  evRebateLink: string
  fuelPricePerLitre: number
  preTaxPerPay: number
}

const ReviewProposal = ({
  isAuthenticated,
  opportunityId,
  consultantFirstName,
  userFirstName,
  payFrequency,
  applicationRole,
  annualRate,
  fbtMethod,
  leaseTerm,
  kmPerAnnum,
  nlFeePerPay,
  financeAmount,
  carRepaymentPerPayExGST,
  totalLeaseRunningCostsPerPayExGST,
  compInsuranceCommissionPerAnnumIncGST,
  compInsuranceProvider,
  gapCoverCommissionPerAnnumIncGST,
  vehicleFBTValue,
  financierEstablishmentFeePerAnnum,
  brokeragePerAnnum,
  residualPCT,
  leaseResidualAmountIncGST,
  nlFeePerAnnumIncGST,
  financierEstablishmentFee,
  financierFeePerPay,
  spFeePerAnnumIncGST,
  extendedWarrantyCommGST,
  extendedWarrantyCommExGST,
  extendenWarrantyCommissionPerAnnumIncGST,
  leaseProtectionCommissionPerAnnumIncGST,
  leaseProtectionCommExGST,
  procurementFee,
  rpcCommissionPerAnnumIncGST,
  rpcCommissionExGST,
  rpcCommGST,
  retailPrice,
  priveawayPrice,
  theme,
  brand,
  ctp,
  registrationFee,
  stampDutyViaDisbursement,
  brokerage,
  compInsuranceCommissionExGST,
  compInsuranceCommGST,
  gapCoverCommissionExGST,
  gapCoverCommGST,
  proposalEstimateId,
  type,
  evRebateApplicable,
  evRebateValue,
  evRebateLink,
  monthlyRepaymentAmountIncGST,
  isExGST,
  preTaxPerPay
}: IInputProps) => {
  interface IStateProposal {
    proposal: {
      isProposalAuthorised: boolean
      OnProposalAcceptance: {
        isSubmitting: boolean
        submissionFailed: boolean
        errorMsgOnAcceptingProposal: string
      }
      proposal: { updatedOn: string; isValid: boolean; quoteId: string }
    }
  }
  interface IStateEstimates {
    estimates: {
      tradeIn: {
        negativeEquityAmount: number
      }
    }
  }
  interface IStateEmployerProps {
    user: { employer: IProposalUserEmployer; isGov: boolean }
  }

  interface IStateIndividualEstimateProps extends IStateEmployerProps {
    individualEstimate: {
      afterMarketAccessories: IAfterMarketAccessoriesProps
      estimate: IProposalEstimateProps
    }
  }

  interface ILocalError {
    id: string
    cardNumber: number
  }
  let dispatch = useDispatch()
  let history = useHistory()
  const isConsultant = applicationRole.isConsultant

  let isEVRebate = useSelector(
    (state: IStateIndividualEstimateProps) =>
      evRebateApplicable &&
      IsVehicleElectric(state.individualEstimate.estimate, false) &&
      (state.individualEstimate.estimate.vehicle && state.individualEstimate.estimate.vehicle.vehicleType && 
        state.individualEstimate.estimate.vehicle.vehicleType.toLowerCase() ==='new')
  )
  
  let showRFBA =
    useSelector((state: IStateIndividualEstimateProps) =>
      IsVehicleElectric(state.individualEstimate.estimate, true)
    ) &&
    vehicleFBTValue &&
    vehicleFBTValue < 84916 &&
    fbtMethod &&
    fbtMethod.toLowerCase() === 'exempt'
  const isGov = useSelector(
    (state: IStateEmployerProps) => state.user.isGov && globals.isBrandRS
  )

  // Special Employer handling
  let takeHomeSectionPointNo = '4. '
  let rfbaPointNo = '5. '
  let authSectionPointNo = showRFBA ? '6. ' : '5. '

  let isRioTinto = IsSpecialEmployer('RIO')
  let isSAGov = IsSpecialEmployer('SAG', false)
  let isNSWHN = IsSpecialEmployer('NSWHN')
  let isSAGBYO = IsSpecialEmployer('SAGBYO') 
  let isREMEQ = IsSpecialEmployer('REMEQ')
  let isACTGO = IsSpecialEmployer('ACTGO')

  if (isSAGov || isNSWHN || isGov || isSAGBYO || isREMEQ || isACTGO ) {
    //Proposal Summary will be displayed as '4.'. Increase these other two.
    takeHomeSectionPointNo = '5. '
    rfbaPointNo = '6. '
    authSectionPointNo = showRFBA ? '7. ' : '6. '
  }
  let rioChecklistData = isRioTinto ? RioTintoFormattedData(theme) : null
  let nswHNChecklistData = isNSWHN ? NswHNFormattedData(theme) : null
  let sagbyoChecklistData = isSAGBYO ? SagByoFormattedData(theme): null

  const showRecommendedRetailPrice = retailPrice > priveawayPrice

  const userEvents = () => {
    if (proposal && proposal.proposal && proposal.proposal.quoteId) {
      dispatch(
        fetchIndividualEstimate(
          opportunityId,
          proposal.proposal.quoteId,
          true,
          true
        )
      )
    }
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'maxxia:mylease:proposal:review' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'maxxia:mylease:proposal:review' },
        },
      })
    }
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'review proposal',
          label: 'review proposal',
        },
      },
    })
  }
  const consultantEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'maxxia:mylease:consultant:estimates:view' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'maxxia:mylease:consultant:estimates:view' },
        },
      })
    }
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'view estimate details',
          label: 'view estimate details',
        },
      },
    })
  }
  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      checkConsultant() ? consultantEvents() : userEvents()
    }
  }, [isAuthenticated, opportunityId])

  let notificationElement = document.getElementById('notification')
  if (notificationElement !== undefined && notificationElement !== null) {
    let n = document.getElementById('notification')
    if (n) n.style.display = 'none'
  }
  let contactConsultantLaunchTxt = 'Contact ' + consultantFirstName

  let proposal = useSelector((state: IStateProposal) => state.proposal)

  var proposalEstimate: IProposalEstimateProps = useSelector(
    (state: IStateIndividualEstimateProps) => state.individualEstimate.estimate
  )

  var userEmployer = useSelector(
    (state: IStateEmployerProps) => state.user.employer
  )

  const [checklistErrors, setChecklistErrors] = useState<ILocalError[]>([])
  const [checkListErrorText, setCheckListErrorText] = useState('')
  const [errorList, setErrorList] = useState<ILocalError[]>([])
  const [errorText, setErrorText] = useState('')
  const [inCheckListErrorState, setInCheckListErrorState] = useState(false)
  const [showSummarySheet, setShowSummarySheet] = useState(false)

  const toggleviewSummarySheet = () => {
    setShowSummarySheet(!showSummarySheet)
  }

  let deductionSectionTitle = () => {
    let title = (isGov || isSAGBYO) ? '3A. ' : '3. '
    if (userEmployer && userEmployer.payFrequency) {
      title += 'Your total ' + userEmployer.payFrequency + ' deductions'
    } else {
      title += 'Your total pay cycle deductions'
    }

    return title
  }

  let isProposalAuthorised = useSelector(
    (state: IStateProposal) => state.proposal.isProposalAuthorised
  )
  let OnProposalAcceptanceState = useSelector(
    (state: IStateProposal) => state.proposal.OnProposalAcceptance
  )

  let negativeEquityAmount = useSelector((state: IStateEstimates) =>
    state.estimates && state.estimates.tradeIn
      ? state.estimates.tradeIn.negativeEquityAmount
      : null
  )
  let proposalUpdatedDate = useSelector((state: IStateProposal) =>
    state.proposal && state.proposal.proposal
      ? state.proposal.proposal.updatedOn
      : null
  )

  let OnAuthorisingProposal = () => {
    if (
      document.getElementById('proposalAuthorisationCheckbox') !== null &&
      document.getElementById('proposalAuthorisationCheckbox') !== undefined
    ) {
      let pac = document.getElementById(
        'proposalAuthorisationCheckbox'
      ) as HTMLInputElement
      if (pac && pac.checked) {
        dispatch(
          OnProposalAuthorisation(
            proposalAuthorisedConstants.PROPOSAL_AUTHORISED
          )
        )
      } else {
        dispatch(
          OnProposalAuthorisation(
            proposalAuthorisedConstants.PROPOSAL_NOT_AUTHORISED
          )
        )
      }
    } else {
      console.log("checkbox doesn't exist")
    }
  }

  const pdfViewClick = () => {
    history.push(history.location.pathname + '/pdfview')

    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'view pdf',
          label: 'view pdf',
        },
      },
    })
  }

  const [txtFullName, setTxtFullName] = useState('')
  const [txtPayrollID, setTxtPayrollID] = useState('')

  const handleTxtFullNameChange = (event: any) => {
    setTxtFullName(event.target.value.trim())
  }

  const handleTxtPayrollIDChange = (event: any) => {
    setTxtPayrollID(event.target.value)
  }

  const afterMarketAccessories = useSelector(
    (state: IStateIndividualEstimateProps) =>
      state.individualEstimate.afterMarketAccessories
  )

  const isSpartaVehicle = useSelector(
    (state: IStateIndividualEstimateProps) =>
      state.individualEstimate.estimate &&
      state.individualEstimate.estimate.vehicle &&
      state.individualEstimate.estimate.vehicle.shadowPR
  )

  const isProposal = useSelector(
    (state: IStateProposal) =>
      state.proposal.proposal && state.proposal.proposal.isValid
  )

  let firstName = useSelector((state: any) => state.user && state.user.firstName)
  let lastName = useSelector((state: any) => state.user && state.user.lastName)

  firstName = firstName && firstName.trim()
  lastName = lastName && lastName.trim()

  let customerName = `${firstName} ${lastName}`

  const customerPayrollId = useSelector(
    (state: any) =>
      state.user && state.user.employer && state.user.employer.payrollId
  )

  let showInterestRate = useSelector(
    (state: IStateEmployerProps) =>
      state.user &&
      state.user.employer &&
      state.user.employer.employerGRS &&
      state.user.employer.employerGRS.displayInterestRateOnDigitalEstimate
  )
  
  let isPAC = useSelector(
    (state: IStateIndividualEstimateProps) =>
      (state.individualEstimate && 
       state.individualEstimate.estimate && 
       state.individualEstimate.estimate.rpcProvider != null &&
       state.individualEstimate.estimate.rpcProvider.toLowerCase() ===
          'pac') ||
      (state.individualEstimate && state.individualEstimate.estimate && state.individualEstimate.estimate.extendedWarrantyProvider != null &&
        state.individualEstimate.estimate.extendedWarrantyProvider.toLowerCase() ===
          'pac')
  )

  const updateErrors = (errorList: ILocalError[], errorText: string) => {
    setChecklistErrors(errorList)
    setCheckListErrorText(errorText)
  }

  const fnValidateUserNameSignature = () => {
    if (txtFullName.toLowerCase() === customerName.toLowerCase()) {
      return true
    } else {
      setErrorText('Please provide your valid full name.')
      return false
    }
  }

  const fnValidatePaylrollIDSignature = () => {
    if (txtPayrollID.toLowerCase() === customerPayrollId.toLowerCase()) {
      return true
    } else {
      setErrorText(
        'Please enter your payroll ID as it appears on your payslip.'
      )
      return false
    }
  }

  const proceedProposal = (pdf?: any) => {
    
    if (isRioTinto || isNSWHN || isSAGBYO) {
      setErrorList(checklistErrors)
      setErrorText(checkListErrorText)
      setInCheckListErrorState(true)

      if (checkListErrorText !== '') return

      if (
        isNSWHN &&
        (!fnValidateUserNameSignature() || !fnValidatePaylrollIDSignature())
      )
        return // Check if the customer has provided the valid full name & payrollID before proceeding with the proposal

      //Push AUTHORISED actionType
      dispatch(
        OnProposalAuthorisation(proposalAuthorisedConstants.PROPOSAL_AUTHORISED)
      )
    }
    //For Rio, the actionType change isn't detected in time, so OR condition in here.
    if (isProposalAuthorised || isRioTinto || isNSWHN || isSAGBYO) {
      
      dispatch(OnProposalAcceptance(opportunityId, proposal, history, pdf))
      fireInteractionCustomEvent({
        detail: {
          eventType: 'custom link click',
          data: {
            category: 'button',
            section: 'mylease',
            text: 'proposal acceptance',
            label: 'proposal acceptance',
          },
        },
      })
    } else if (isProposalAuthorised === undefined) {
      dispatch(
        OnProposalAuthorisation(
          proposalAuthorisedConstants.PROPOSAL_NOT_AUTHORISED
        )
      )
    }
  }
  const quoteId = proposal && proposal.proposal && proposal.proposal.quoteId
  
  const carImageSectionData: IProposalVehicleProps = {
    ...proposalEstimate.vehicle,
    vehicleType: proposalEstimate.vehicleType,
    vehicleDescription: proposalEstimate.vehicleDescription,
  }

  let novatedLeaseSectionData: IProposalNovatedLeaseSectionProps = {
    negativeEquityAmount: negativeEquityAmount,
    downloadingPdf: false,
    pdf: false,
    compInsurancePremium:
      proposalEstimate && proposalEstimate.compInsurancePremium,
    compInsuranceProvider:
      proposalEstimate && proposalEstimate.compInsuranceProvider,
    driveawayPrice: proposalEstimate && proposalEstimate.driveawayPrice,
    evRebateApplicable: evRebateApplicable,
    evRebateValue: evRebateValue,
    evRebateLink: evRebateLink,
    extendedWarrantyPremium:
      proposalEstimate && proposalEstimate.extendedWarrantyPremium,
    extendedWarrantyProvider:
      proposalEstimate && proposalEstimate.extendedWarrantyProvider,
    extendedWarrantyTerm:
      proposalEstimate && proposalEstimate.extendedWarrantyTerm,
    financeAmount: proposalEstimate && proposalEstimate.financeAmount,
    financierEstablishmentFee:
      proposalEstimate && proposalEstimate.financierEstablishmentFee,
    financierFeePerPay: proposalEstimate && proposalEstimate.financierFeePerPay,
    gapCoverPremium: proposalEstimate && proposalEstimate.gapCoverPremium,
    gstCreditClaimable: proposalEstimate && proposalEstimate.gstCreditClaimable,
    kmPerAnnum: proposalEstimate && proposalEstimate.kmPerAnnum,
    leaseProtectionPremium:
      proposalEstimate && proposalEstimate.leaseProtectionPremium,
    leaseResidualAmountIncGST:
      proposalEstimate && proposalEstimate.leaseResidualAmountIncGST,
    leaseTerm: proposalEstimate && proposalEstimate.leaseTerm,
    leaseTermYears: proposalEstimate && proposalEstimate.leaseTermYears,
    priveawayPrice: proposalEstimate && proposalEstimate.priveawayPrice,
    rpcPremium: proposalEstimate && proposalEstimate.rpcPremium,
    rpcProvider: proposalEstimate && proposalEstimate.rpcProvider,
    vehicle: proposalEstimate && {
      ...proposalEstimate.vehicle,
      vehicleType: proposalEstimate && proposalEstimate.vehicleType,
    },
    productId: proposalEstimate && proposalEstimate.productId,
    compInsurancePremiumFinanced:
      proposalEstimate && proposalEstimate.compInsurancePremiumFinanced,
    vehicleFBTValue: proposalEstimate && proposalEstimate.vehicleFBTValue,
  }

  let summarySheetData: IProposalSummarySheetProps = {
    proposalEstimate: {
      annualRate: proposalEstimate && proposalEstimate.annualRate, 
      brokerage: proposalEstimate && proposalEstimate.brokerage,
      carRepaymentPerAnnumIncGST:
        proposalEstimate && proposalEstimate.carRepaymentPerAnnumIncGST,
      compInsPerAnnumIncGST:
        proposalEstimate && proposalEstimate.compInsPerAnnumIncGST,
      compInsurance: proposalEstimate && proposalEstimate.compInsurance,
      compInsurancePremium: proposalEstimate && proposalEstimate.compInsurancePremium,
      dealerDelivery: proposalEstimate && proposalEstimate.vehicle.deliveryFee,
      electricityPerAnnumIncGST: proposalEstimate && proposalEstimate.electricityPerAnnumExGST,
      extendedWarrantyPremium: proposalEstimate && proposalEstimate.extendedWarrantyPremium,
      fbtPerAnnum: proposalEstimate && proposalEstimate.fbtPerAnnum,
      financeAmount: proposalEstimate && proposalEstimate.financeAmount,
      financierEstablishmentFee: proposalEstimate && proposalEstimate.financierEstablishmentFee,
      fuelPerAnnumIncGST:
        proposalEstimate && proposalEstimate.fuelPerAnnumIncGST,
      fuelPricePerLitre: proposalEstimate && proposalEstimate.fuelPricePerLitre,
      fuelType: proposalEstimate && proposalEstimate.vehicle.fuelType,
      gapCoverPremium: proposalEstimate && proposalEstimate.gapCoverPremium,
      gstCreditClaimable: proposalEstimate && proposalEstimate.gstCreditClaimable,
      kmPerAnnum: proposalEstimate && proposalEstimate.kmPerAnnum,
      leaseProtectionPremium: proposalEstimate && proposalEstimate.leaseProtectionPremium,
      leaseRepayment:proposalEstimate && proposalEstimate.leaseRepayment,
      leaseResidualAmountIncGST:
        proposalEstimate && proposalEstimate.leaseResidualAmountIncGST,
      leaseTerm: proposalEstimate && proposalEstimate.leaseTerm,
      leaseTermYears: proposalEstimate && proposalEstimate.leaseTermYears,
      luxuryCarTax: proposalEstimate && proposalEstimate.vehicle.luxuryCarTax,
      maintenancePerAnnumIncGST:
        proposalEstimate && proposalEstimate.maintenancePerAnnumIncGST,
      maintenancePerPayIncGST:
        proposalEstimate && proposalEstimate.maintenancePerPayIncGST,
      nlFeePerAnnumIncGST:
        proposalEstimate && proposalEstimate.nlFeePerAnnumIncGST,
      noOfServices: proposalEstimate && proposalEstimate.noOfServices,
      noOfTyresBudget: proposalEstimate && proposalEstimate.noOfTyresBudget,
      otherRunningCostsPerAnnumIncGST:
        proposalEstimate && proposalEstimate.otherRunningCostsPerAnnumIncGST,
      productId: proposalEstimate && proposalEstimate.productId,
      regoPerAnnumExGST: proposalEstimate && proposalEstimate.regoPerAnnumExGST,
      rpcPremium:proposalEstimate && proposalEstimate.rpcPremium,
      specm: proposalEstimate && proposalEstimate.specm,
      spPreTaxDeduction: proposalEstimate && proposalEstimate.spPreTaxDeduction,
      taxandMedicareSavings:
        proposalEstimate && proposalEstimate.taxandMedicareSavings,
      totalPackagePerPayExGSTTaxShare: proposalEstimate && proposalEstimate.totalPackagePerPayExGSTTaxShare,
      totalPackagePerPayExGST: proposalEstimate && proposalEstimate.totalPackagePerPayExGST,
      totalPackagePerPayIncGST: proposalEstimate && proposalEstimate.totalPackagePerPayIncGST,
      totalVehicleValueExGST: proposalEstimate && proposalEstimate.totalVehicleValueExGST,
      tyresPerAnnumIncGST:
        proposalEstimate && proposalEstimate.tyresPerAnnumIncGST,
      vehicle: proposalEstimate && proposalEstimate.vehicle,
      vehicleFBTValue: proposalEstimate && proposalEstimate.vehicleFBTValue,
      vehicleType: proposalEstimate && proposalEstimate.vehicleType
    },
  }
  const bpFC = useSelector((state: any) => state.opportunity.bpFuelProvider)
  const caltexFC = useSelector((state: any) => state.opportunity.caltexFuelProvider)
  const shellFC = useSelector((state: any) => state.opportunity.shellFuelProvider)

  let fuelCards: string[] = []
  if (bpFC)
      fuelCards.push('BP')
  if (caltexFC)
      fuelCards.push('Ampol')
  if (shellFC)
      fuelCards.push('Shell')

  let accessories: string[] = []
  const thirdPartyAccessories = useSelector((state:any) => state.individualEstimate.estimate && 
      state.individualEstimate.estimate.vehicle && 
      state.individualEstimate.estimate.vehicle.thirdPartyOption &&
      state.individualEstimate.estimate.vehicle.thirdPartyOption.thirdPartyOptionLines)
  if(thirdPartyAccessories) {accessories.push(thirdPartyAccessories.map((x: any) => x.description))}
  const vehicleAccessories = useSelector((state:any) => state.individualEstimate.estimate && 
      state.individualEstimate.estimate.vehicle && 
      state.individualEstimate.estimate.vehicle.vehicleAccessories)
  if(vehicleAccessories) {accessories.push(vehicleAccessories.map((x: any) => x.name))}
  const aftermarketOrderLines = afterMarketAccessories && afterMarketAccessories.aftermarketOrderLines
  aftermarketOrderLines && aftermarketOrderLines.forEach((item: any) => (accessories.push( item.description)))

  let summarySheetMXData: any = {
    ...proposalEstimate,
    employeeName: customerName,
    employeeNumber: customerPayrollId,
    fuelCards,
    isExGST,
    payFrequency,
    accessories
  }
  const deductionSectionData: IProposalDeductionSectionProps = {
    annualRate: proposalEstimate && proposalEstimate.annualRate,
    carRepaymentPerAnnumExGST:
      proposalEstimate && proposalEstimate.carRepaymentPerAnnumExGST,
    carRepaymentPerAnnumIncGST:
      proposalEstimate && proposalEstimate.carRepaymentPerAnnumIncGST,
    carRepaymentPerPayExGST:
      proposalEstimate && proposalEstimate.carRepaymentPerPayExGST,
    carRepaymentPerPayIncGST:
      proposalEstimate && proposalEstimate.carRepaymentPerPayIncGST,
    compInsPerAnnumExGST:
      proposalEstimate && proposalEstimate.compInsPerAnnumExGST,
    compInsPerAnnumIncGST:
      proposalEstimate && proposalEstimate.compInsPerAnnumIncGST,
    compInsPerPayExGST: proposalEstimate && proposalEstimate.compInsPerPayExGST,
    compInsPerPayIncGST:
      proposalEstimate && proposalEstimate.compInsPerPayIncGST,
    compInsurancePremium:
      proposalEstimate && proposalEstimate.compInsurancePremium,
    compInsuranceProvider:
      proposalEstimate && proposalEstimate.compInsuranceProvider,
    electricityCostPerKm:
      proposalEstimate && proposalEstimate.electricityCostPerKm,
    electricityPerPayExGST:
      proposalEstimate && proposalEstimate.electricityPerPayExGST,
    electricityPerPayIncGST:
      proposalEstimate && proposalEstimate.electricityPerPayIncGST,
    electricityPerAnnumExGST:
      proposalEstimate && proposalEstimate.electricityPerAnnumExGST,
    electricityPerAnnumIncGST:
      proposalEstimate && proposalEstimate.electricityPerAnnumIncGST,
    erAdminFeePerAnnum: proposalEstimate && proposalEstimate.erAdminFeePerAnnum,
    erAdminFeePerPay: proposalEstimate && proposalEstimate.erAdminFeePerPay,
    erShare: proposalEstimate && proposalEstimate.erShare,
    erSharePerAnnum: proposalEstimate && proposalEstimate.erSharePerAnnum,
    erSharePerPay: proposalEstimate && proposalEstimate.erSharePerPay,
    extendedWarrantyPremium:
      proposalEstimate && proposalEstimate.extendedWarrantyPremium,
    fbtMethod: proposalEstimate && proposalEstimate.fbtMethod,
    fbtPerAnnum: proposalEstimate && proposalEstimate.fbtPerAnnum,
    fbtPerPay: proposalEstimate && proposalEstimate.fbtPerPay,
    financierEstablishmentFee:
      proposalEstimate && proposalEstimate.financierEstablishmentFee,
    financierFeePerPay: proposalEstimate && proposalEstimate.financierFeePerPay,
    fuelPerAnnumExGST: proposalEstimate && proposalEstimate.fuelPerAnnumExGST,
    fuelPerAnnumIncGST: proposalEstimate && proposalEstimate.fuelPerAnnumIncGST,
    fuelPerPayExGST: proposalEstimate && proposalEstimate.fuelPerPayExGST,
    fuelPerPayIncGST: proposalEstimate && proposalEstimate.fuelPerPayIncGST,
    fuelPricePerLitre: proposalEstimate && proposalEstimate.fuelPricePerLitre,
    gapCoverPremium: proposalEstimate && proposalEstimate.gapCoverPremium,
    greenfleetPerAnnum: proposalEstimate && proposalEstimate.greenfleetPerAnnum,
    greenfleetPerPay: proposalEstimate && proposalEstimate.greenfleetPerPay,
    gstOnECMPerAnnum: proposalEstimate && proposalEstimate.gstOnECMPerAnnum,
    gstOnECMPerPay: proposalEstimate && proposalEstimate.gstOnECMPerPay,
    incidentalsPerAnnumExGST:
      proposalEstimate && proposalEstimate.incidentalsPerAnnumExGST,
    incidentalsPerAnnumIncGST:
      proposalEstimate && proposalEstimate.incidentalsPerAnnumIncGST,
    incidentalsPerPayExGST:
      proposalEstimate && proposalEstimate.incidentalsPerPayExGST,
    incidentalsPerPayIncGST:
      proposalEstimate && proposalEstimate.incidentalsPerPayIncGST,
    isGov: isGov,
    lcdaPerAnnum: proposalEstimate && proposalEstimate.lcdaPerAnnum,
    lcdaPerPay: proposalEstimate && proposalEstimate.lcdaPerPay,
    leaseProtectionPremium:
      proposalEstimate && proposalEstimate.leaseProtectionPremium,
    leaseTerm: proposalEstimate && proposalEstimate.leaseTerm,
    leaseTermYears: proposalEstimate && proposalEstimate.leaseTermYears,
    maintenancePerAnnumExGST:
      proposalEstimate && proposalEstimate.maintenancePerAnnumExGST,
    maintenancePerAnnumIncGST:
      proposalEstimate && proposalEstimate.maintenancePerAnnumIncGST,
    maintenancePerPayExGST:
      proposalEstimate && proposalEstimate.maintenancePerPayExGST,
    maintenancePerPayIncGST:
      proposalEstimate && proposalEstimate.maintenancePerPayIncGST,
    nlFeePerAnnumExGST: proposalEstimate && proposalEstimate.nlFeePerAnnumExGST,
    nlFeePerAnnumIncGST:
      proposalEstimate && proposalEstimate.nlFeePerAnnumIncGST,
    nlFeePerPayExGST: proposalEstimate && proposalEstimate.nlFeePerPayExGST,
    nlFeePerPayIncGST: proposalEstimate && proposalEstimate.nlFeePerPayIncGST,
    noOfTyresBudget: proposalEstimate && proposalEstimate.noOfTyresBudget,
    outOfPocketPerPay: proposalEstimate && proposalEstimate.outOfPocketPerPay,
    overTheCapMethod: proposalEstimate && proposalEstimate.overTheCapMethod,
    payFrequency: userEmployer.payFrequency,
    regoPerAnnumExGST: proposalEstimate && proposalEstimate.regoPerAnnumExGST,
    regoPerAnnumIncGST: proposalEstimate && proposalEstimate.regoPerAnnumIncGST,
    regoPerPayExGST: proposalEstimate && proposalEstimate.regoPerPayExGST,
    regoPerPayIncGST: proposalEstimate && proposalEstimate.regoPerPayIncGST,
    roadsideAssist: proposalEstimate && proposalEstimate.roadsideAssist,
    roadsidePerAnnumExGST:
      proposalEstimate && proposalEstimate.roadsidePerAnnumExGST,
    roadsidePerAnnumIncGST:
      proposalEstimate && proposalEstimate.roadsidePerAnnumIncGST,
    roadsidePerPayExGST:
      proposalEstimate && proposalEstimate.roadsidePerPayExGST,
    roadsidePerPayIncGST:
      proposalEstimate && proposalEstimate.roadsidePerPayIncGST,
    rpcPremium: proposalEstimate && proposalEstimate.rpcPremium,
    spFeePerAnnumExGST: proposalEstimate && proposalEstimate.spFeePerAnnumExGST,
    spFeePerAnnumIncGST:
      proposalEstimate && proposalEstimate.spFeePerAnnumIncGST,
    spFeePerPayExGST: proposalEstimate && proposalEstimate.spFeePerPayExGST,
    spFeePerPayIncGST: proposalEstimate && proposalEstimate.spFeePerPayIncGST,
    taxandMedicareSavingsLifeofLease: proposalEstimate && proposalEstimate.taxandMedicareSavingsLifeofLease,
    taxShare: proposalEstimate && proposalEstimate.taxShare,
    totalChargesPerPayExGST:
      proposalEstimate && proposalEstimate.totalChargesPerPayExGST,
    totalChargesPerPayExGSTTaxShare:
      proposalEstimate && proposalEstimate.totalChargesPerPayExGSTTaxShare,
    totalChargesPerPayIncGST:
      proposalEstimate && proposalEstimate.totalChargesPerPayIncGST,
    totalChargesPerPayIncGSTTaxShare:
      proposalEstimate && proposalEstimate.totalChargesPerPayIncGSTTaxShare,
    totalPackagePerAnnumExGST:
      proposalEstimate && proposalEstimate.totalPackagePerAnnumExGST,
    totalPackagePerAnnumIncGST:
      proposalEstimate && proposalEstimate.totalPackagePerAnnumIncGST,
    totalPackagePerPayExGST:
      proposalEstimate && proposalEstimate.totalPackagePerPayExGST,
    totalPackagePerPayIncGST:
      proposalEstimate && proposalEstimate.totalPackagePerPayIncGST,
    totalPackagePerPayExGSTTaxShare:
      proposalEstimate && proposalEstimate.totalPackagePerPayExGSTTaxShare,
    totalPackagePerPayIncGSTTaxShare:
      proposalEstimate &&
      proposalEstimate.totalPackagePerPayExGSTTaxShare &&
      proposalEstimate.totalPackagePerPayExGSTTaxShare * 1.1,
    tyresPerAnnumExGST: proposalEstimate && proposalEstimate.tyresPerAnnumExGST,
    tyresPerAnnumIncGST:
      proposalEstimate && proposalEstimate.tyresPerAnnumIncGST,
    tyresPerPayExGST: proposalEstimate && proposalEstimate.tyresPerPayExGST,
    tyresPerPayIncGST: proposalEstimate && proposalEstimate.tyresPerPayIncGST,
    updatedOn: proposalEstimate && proposalEstimate.updatedOn,
    vehicle: proposalEstimate && proposalEstimate.vehicle,
      
  }

  const takeHomeSectionData = {
    grossSalaryPerPay: proposalEstimate && proposalEstimate.grossSalaryPerPay,
    preTaxPerPay: proposalEstimate && proposalEstimate.preTaxPerPay,
    otherPreTaxPerPay: proposalEstimate && proposalEstimate.otherPreTaxPerPay,
    netSalaryPerPay: proposalEstimate && proposalEstimate.netSalaryPerPay,
    taxMedicarePerPay: proposalEstimate && proposalEstimate.taxMedicarePerPay,
    netIncomePerPay: proposalEstimate && proposalEstimate.netIncomePerPay,
    postTaxPerPay: proposalEstimate && proposalEstimate.postTaxPerPay,
    otherPostTaxPerPay: proposalEstimate && proposalEstimate.otherPostTaxPerPay,
    takeHomePerPay: proposalEstimate && proposalEstimate.takeHomePerPay,
    fbtPerPay: proposalEstimate && proposalEstimate.fbtPerPay,
    fbtMethod: proposalEstimate && proposalEstimate.fbtMethod,
    vehicleFBTValue: proposalEstimate && proposalEstimate.vehicleFBTValue,
    overTheCapMethod: proposalEstimate && proposalEstimate.overTheCapMethod,
    taxShare: proposalEstimate && proposalEstimate.taxShare,
    taxSharePerPay: proposalEstimate && proposalEstimate.taxSharePerPay,
  }

  let estimateSummaryProps = {
    title: '4. Proposal Summary',
    employerCode: isSAGov ? 'SAG' : isNSWHN ? 'NSWHN' : isGov ? 'QG' : isSAGBYO ? 'SAGBYO' : '',
    financeAmount: financeAmount,
    carRepaymentPerPayExGST: carRepaymentPerPayExGST,
    leaseResidualAmountIncGST: leaseResidualAmountIncGST,
    residualPCT: residualPCT,
    totalLeaseRunningCostsPerPayExGST: totalLeaseRunningCostsPerPayExGST,
    employerDisplayInterestRateOnDigitalEstimate: showInterestRate,
    annualRate: annualRate,
    nlFeePerPayExGST: proposalEstimate && proposalEstimate.nlFeePerPayExGST,
    vehicleFBTValue: vehicleFBTValue,
    vehicleProcurementFee: procurementFee,
    leaseTerm: leaseTerm,
    isPAC: isPAC,
    compInsuranceCommissionPerAnnumIncGST:
      compInsuranceCommissionPerAnnumIncGST,
    compInsuranceCommissionExGST:
      proposalEstimate && proposalEstimate.compInsuranceCommissionExGST,
    compInsuranceCommGST:
      proposalEstimate && proposalEstimate.compInsuranceCommGST,
    gapCoverCommissionPerAnnumIncGST: gapCoverCommissionPerAnnumIncGST,
    gapCoverCommissionExGST:
      proposalEstimate && proposalEstimate.gapCoverCommissionExGST,
    gapCoverCommGST: proposalEstimate && proposalEstimate.gapCoverCommGST,
    rpcCommissionPerAnnumIncGST: rpcCommissionPerAnnumIncGST,
    rpcCommissionExGST: rpcCommissionExGST,
    rpcCommGST: rpcCommGST,
    extendenWarrantyCommissionPerAnnumIncGST:
      extendenWarrantyCommissionPerAnnumIncGST,
    extendedWarrantyCommExGST: extendedWarrantyCommExGST,
    extendedWarrantyCommGST:
      proposalEstimate && proposalEstimate.extendedWarrantyCommGST,
    leaseProtectionCommissionPerAnnumIncGST:
      leaseProtectionCommissionPerAnnumIncGST,
    leaseProtectionCommExGST: leaseProtectionCommExGST,
    leaseProtectionCommGST:
      proposalEstimate && proposalEstimate.leaseProtectionCommGST,
    financierEstablishmentFeePerAnnum: financierEstablishmentFeePerAnnum,
    financierEstablishmentFee: financierEstablishmentFee,
    brokeragePerAnnum: brokeragePerAnnum,
    brokerage: proposalEstimate && proposalEstimate.brokerage,
    nlFeePerPay: nlFeePerPay,
    kmPerAnnum: kmPerAnnum,
    financierFeePerPay: proposalEstimate && proposalEstimate.financierFeePerPay,
    monthlyRepaymentAmountIncGST: proposalEstimate && proposalEstimate.monthlyRepaymentAmountIncGST,
    specm: proposalEstimate && proposalEstimate.specm,
    payFrequency: payFrequency,
    fbtMethod: fbtMethod,
    preTaxPerPay: preTaxPerPay
  }

  const scrollZen = (about: string) => {
    var myDiv: HTMLElement | null = document.getElementById(about)
    if (myDiv) {
      zenscroll.to(myDiv, 100)
    }
  }

  let pdfInBase64: any = ''
  let defaultDate = new Date()
  defaultDate.setDate(defaultDate.getDate())
  const [date, ] = useState(defaultDate)

  const [displayCustomPdf, setDisplayCustomPdf] = useState(false)
  const onClickCustomPdf = () => {
    setDisplayCustomPdf(true)
    //Print div then disable
    dispatch(startedPdfDownload())
    setTimeout(function () {
      pdfInBase64 = createPdfBase64('Test', 'pdf1', (pdf?: any) => {
        setDisplayCustomPdf(false)
        onPdfProcessComplete(pdf)
      })
    }, 250)
  }

  const onPdfProcessComplete = (pdf: any) => {
    dispatch(finishedPdfDownload())
    proceedProposal(pdf)
  }

  let hasChecklist = (isRioTinto && rioChecklistData) ||
                    (isNSWHN && nswHNChecklistData) || 
                    (isSAGBYO && sagbyoChecklistData)
  let checklistData = isRioTinto ? rioChecklistData : 
    isNSWHN ? nswHNChecklistData :
    isSAGBYO ? sagbyoChecklistData : 
    null

  return (
    <>
      <Layout>
        <Modal
          show={showSummarySheet}
          onHide={toggleviewSummarySheet}
          size="lg"
        >
          <Modal.Header
            closeButton
            style={{
              background: 'transparent',
              borderBottom: 'none',
              paddingBottom: 0,
            }}
          ></Modal.Header>
          <Modal.Body>
            <div>
              {isBrandRS && <SummarySheet novatedLeaseData={summarySheetData} exGst={true} />}
              {isBrandMX && <SummarySheetMX summarySheetData={summarySheetMXData}/>}
            </div>
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: 'start' }}>
            <PrimaryButton extendInMob onClick={pdfViewClick}>
              View PDF
            </PrimaryButton>
            <PrimaryButton
              extendInMob
              invertColor
              onClick={toggleviewSummarySheet}
            >
              Close
            </PrimaryButton>
          </Modal.Footer>
        </Modal>
        <E.ProposalReviewPage>
          <E.SubMenuContainer>
            <SubMenuBar
              background="#000"
              color="#fff"
              buttons={[
                {
                  name: 'Car Details',
                  onClick: () => {
                    scrollZen('cardetailssection')
                  },
                  active: true,
                },
                {
                  name: 'Your Novated Lease',
                  onClick: () => {
                    scrollZen('novatedleasesection')
                  },
                  active: false,
                },
                {
                  name: 'Your Total Deductions',
                  onClick: () => {
                    scrollZen('deductionsection')
                  },
                  active: false,
                },
                {
                  name: 'Your Take Home Pay',
                  onClick: () => {
                    scrollZen('takehomesection')
                  },
                  active: false,
                },
                {
                  name: 'Your Authorisation',
                  onClick: () => {
                    scrollZen('authorisation')
                  },
                  active: false,
                },
                {
                  name: 'Important Info',
                  onClick: () => {
                    scrollZen('termsandconditions')
                  },
                  active: false,
                },
              ]}
              viewPdf={{
                name: 'View PDF',
                onClick: pdfViewClick,
              }}
            />
          </E.SubMenuContainer>

          <BannerMainImageSection
            id="estimatetobereviewedstage.bannermainsection"
            isHomePage={false}
            isLeftAlign={true}
            isProposal={true}
          >
            <Col lg={7} xs={12}>
              <E.BannerInfoTitle id="proposalindex.bannertitle">
                That wide open road is in sight!
              </E.BannerInfoTitle>
              <E.BannerInfoContent>
                Review the ins and outs of your proposal, before giving it
                the tick to proceed.
              </E.BannerInfoContent>
              <E.BannerInfoContent>
                Want changes {userFirstName}?{' '}
                {isConsultant ? (
                  <E.BannerInfolink
                    href="#root"
                    className="link text-underline readonly"
                    id="proposalindex.contactconsultantreadonly"
                  >
                    {contactConsultantLaunchTxt}
                  </E.BannerInfolink>
                ) : (
                  <ContactUsDialog
                    className="link font-weight-bold text-underline"
                    theme="link"
                    launchText={contactConsultantLaunchTxt}
                    id="proposalindex.contactconsultant1"
                  />
                )}{' '}
                to make them.
              </E.BannerInfoContent>
            </Col>
          </BannerMainImageSection>

          {isSpartaVehicle && (
            <AlertBlockComponent
              isWarning={false}
              extended
              heading="This car has limited availability, please accept your proposal in a timely manner."
              icon={
                <div>
                  <InfoTriangleIcon />
                </div>
              }
            />
          )}
          {isEVRebate && (
            <div id="proposalindex.infobanner">
              <SpartaCustomerCount
                line1={
                  `This electric vehicle may be eligible for a ${formatCurrency(evRebateValue)} EV Bonus!`
                }
                line2={
                  `For more information, chat to your consultant. The ${formatCurrency(evRebateValue)} EV Bonus is not included in any calculations below. ` +
                  ('<a href=' + evRebateLink +
                    ' target="_blank" rel="noopener noreferrer" class="link">' +
                    'Terms &amp; Conditions Apply' +
                    '</a>')
                }
                extended={false}
                icon={<EVBolt />}
                iconTopLine={true}
                spacingValue={3}
              />
            </div>
          )}
          {!proposalEstimate && (
            <Container>
              {/* bootstrap styles keep'em?? */}
              <div className="mt-5 mb-5 d-flex justify-content-center">
                {globals.isBrandMX && (
                  <MaxxiaImage imageName={'Loader'} alt="" />
                )}
                {globals.isBrandRS && (
                  <RemServImage imageName={'Loader'} alt="" />
                )}
              </div>
            </Container>
          )}

          {proposalEstimate && (
            <>
              <CarImageSection
                vehicle={carImageSectionData}
                pdf={false}
                proposalUpdatedDate={proposalUpdatedDate}
              />
              <div id="carDetails">
                <CarDetailsSection
                  vehicle={carImageSectionData}
                  title="1. The car details"
                  proposalUpdatedDate={proposalUpdatedDate}
                />
              </div>
              <div id="summary">
                <NovatedLeaseSection
                  data={novatedLeaseSectionData}
                  title="2. Your novated lease"
                  afterMarketAccessories={afterMarketAccessories}
                  isProposal={isProposal}
                  theme={theme}
                />
              </div>
              <div id="budget">
                <DeductionSection
                  data={deductionSectionData}
                  title={deductionSectionTitle()}
                  userEmployer={userEmployer}
                  theme={theme}
                  proposalEstimateId={quoteId}
                />
              </div>
              {(isGov || isSAGBYO) && (
                <DeductionSection
                  data={deductionSectionData}
                  userEmployer={userEmployer}
                  title={'3B. Your total annual deductions'}
                  isAnnual={true}
                  proposalEstimateId={quoteId}
                  theme={theme}
                />
              )}
              {(isGov || isSAGov || isNSWHN || isSAGBYO || isREMEQ || isACTGO ) && (
                <Container className="section mt-4">
                  <EstimateSummarySection {...estimateSummaryProps} />
                </Container>
              )}

              <TakeHomeSection
                data={takeHomeSectionData}
                pdf={false}
                title={takeHomeSectionPointNo + 'Your resulting take home pay'}
              />

              {showRFBA && (
                <RfbaSection
                  includeContainer={true}
                  pdf={false}
                  title={
                    rfbaPointNo +
                    'Electric vehicle FBT exemption - WHAT YOU NEED TO KNOW'
                  }
                />
              )}

              {hasChecklist &&  (
                <ChecklistSection
                  checklistData={checklistData}
                  updateErrors={updateErrors}
                  errorList={errorList}
                  theme={theme}
                  inErrorState={inCheckListErrorState}
                  id="authorisation"
                />
              )} 

              <div>
                <Container className="section mt-4" id="authorisation">
                  {!hasChecklist && (
                    <div>
                      <Card className="mb-13rem">
                        <Card.Header className="border-bottom-0">
                          <E.CardHeader>
                            {authSectionPointNo}Your authorisation
                          </E.CardHeader>
                        </Card.Header>
                        <Card.Body>
                          <E.BrandDefaultText>
                            <ol className="pl-3">
                              <li className="mb-1">
                                This is the lease I have discussed with my
                                consultant, and I'm happy to proceed.
                              </li>
                              <li className="mb-1">
                                I acknowledge that the prices and rates
                                specified above may be subject to change by the
                                manufacturer or relevant authorities before
                                delivery.
                              </li>
                              {globals.isBrandMX && (
                                <li className="mb-1">
                                  I acknowledge that Maxxia may receive
                                  commissions or rebates and retain interest
                                  earned on moneys held in connection with some
                                  services it provides or arranges to be
                                  provided by third Parties.
                                </li>
                              )}
                              <li className="mb-1">
                                I understand that the lease insurances are
                                {globals.isBrandMX ? ' add-on' : ' optional'},
                                and that I won't be able to add them once my
                                lease has begun. Before making a decision on
                                these products I have read the
                                <span>
                                  {' '}
                                  <E.PDSLink
                                    href={
                                      globals.isBrandMX
                                        ? 'https://www.maxxia.com.au/insurance/novated-lease#pds'
                                        : 'https://www.remserv.com.au/insurance/novated-lease'
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    id="proposalindex.pdslink"
                                  >
                                    Product Disclosure Statements
                                  </E.PDSLink>
                                  .
                                </span>
                              </li>
                              {isGov && (
                                <li className="mb-1">
                                  I have read the{' '}
                                  <E.LinkText onClick={toggleviewSummarySheet}>
                                    summary sheet
                                  </E.LinkText>{' '}
                                  associated with this proposal.
                                </li>
                              )}
                            </ol>
                          </E.BrandDefaultText>
                        </Card.Body>
                      </Card>

                      <E.AuthorizationText
                        className="print hide-to-print"
                        theme={theme}
                      >
                        <input
                          type="checkbox"
                          id="proposalAuthorisationCheckbox"
                          onChange={OnAuthorisingProposal}
                        />
                        <E.BrandDefaultText>
                          I have read and agree with the above statements.
                          {showRFBA && (
                            <div>
                              I understand the conditions of the Electric
                              Vehicle FBT exemption.
                            </div>
                          )}
                        </E.BrandDefaultText>
                      </E.AuthorizationText>

                      {isProposalAuthorised === false && (
                        <Alert
                          variant="danger"
                          className="text-left mt-3 w-100"
                          id="proposalindex.error"
                        >
                          <MdErrorOutline
                            color="#AD240A"
                            size={`1.6em`}
                            style={{
                              minWidth: '20px',
                              position: 'absolute',
                              left: '3px',
                            }}
                          />
                          <div className="text-small ml-3">
                            <div className="mb-1">
                              You must agree to the above statements (in the{' '}
                              <i>Your Authorisation</i> section) to proceed with
                              proposal.
                            </div>
                          </div>
                        </Alert>
                      )}
                    </div>
                  )}

                  {hasChecklist && errorText !== '' && (

                    <div>
                      <Alert
                        variant="danger"
                        className="text-left mt-3 w-100"
                        id="proposalindex.checklisterror"
                      >
                        <MdErrorOutline
                          color="#AD240A"
                          size={`1.6em`}
                          style={{
                            minWidth: '20px',
                            position: 'absolute',
                            left: '3px',
                          }}
                        />
                        <div className="text-small ml-3">
                          <div
                            className="mb-1"
                            dangerouslySetInnerHTML={{ __html: errorText }}
                          ></div>
                        </div>
                      </Alert>
                    </div>
                  )}

                  {isNSWHN && (
                    <>
                      <Container>
                        <Row>
                          <Col lg={8} md={12} style={{ width: '100%' }}>
                            <div className="mt-2 mb-2">Your Payroll Id</div>
                            <input
                              type="text"
                              id="txtPayrollID"
                              name="txtPayrollID"
                              onChange={handleTxtPayrollIDChange}
                              style={{
                                width: 'inherit',
                                height: '44px',
                                padding: '0 16px',
                              }}
                              className="border rounded"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={8} md={12} style={{ width: '100%' }}>
                            <div className="mt-2 mb-2">Your Full Name</div>
                            <input
                              type="text"
                              id="txtFullName"
                              name="txtFullName"
                              onChange={handleTxtFullNameChange}
                              style={{
                                width: 'inherit',
                                height: '44px',
                                padding: '0 16px',
                              }}
                              className="border rounded"
                            />
                          </Col>
                          <Col lg={4} md={12}>
                            <div className="mt-2 mb-2">Date Signed</div>
                            <input
                              type="text"
                              value={formatDate(date)}
                              disabled
                              style={{
                                height: '40px',
                                padding: '0 16px',
                                borderRadius: '40px',
                                width: '150px',
                              }}
                              className="border"
                            />
                          </Col>
                        </Row>
                        <div className="mt-2">
                          I confirm that I have read and agree with the above
                          statements.
                        </div>
                      </Container>
                      <br />
                    </>
                  )}

                  <E.ButtonContainer className="mt-3">
                    {(isGov || IsSpecialEmployer('REMEQ') || IsSpecialEmployer('VICPO')) && (
                      <PrimaryButton
                        invertColor
                        onClick={toggleviewSummarySheet}
                        className="mb-3 ml-3 mr-3"
                      >
                        <RemServIcon iconType="Sheet" size={1} />
                        View summary sheet
                      </PrimaryButton>
                    )}
                    {OnProposalAcceptanceState.isSubmitting ? (
                      <PrimaryButton size="lg">
                        <>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="mb-1"
                          />
                          Submitting...
                        </>
                      </PrimaryButton>
                    ) : (
                      <PrimaryButton
                        disabled={isConsultant}
                        onClick={onClickCustomPdf}
                        id="proposalindex.proceedbutton"
                        className="mb-3 ml-3 mr-3"
                      >
                        Proceed with proposal
                      </PrimaryButton>
                    )}
                    {isRioTinto && !isConsultant && (
                      <a
                        href="/pdfs/Maxxia_MonthlyBudgetPlanner.pdf"
                        download
                        id="proposalindex.budgetplannerlink"
                      >
                        <E.BudgetPlannerButton invertColor={true}>
                          Download Budget Planner
                        </E.BudgetPlannerButton>
                      </a>
                    )}
                  </E.ButtonContainer>
                  <div className="text-center mt-3 mb-4 print hide-to-print">
                    {(isGov || globals.isBrandMX) && (
                      <ContactUsDialog
                        variant="outline-primary"
                        className={
                          globals.isBrandRS
                            ? 'link font-weight-bold text-underline mb-3 primary'
                            : 'text-medium link' +
                              (isConsultant ? ' readonly' : '')
                        }
                        theme="link"
                        launchText="Contact consultant for changes"
                        id="proposalindex.contactconsultant2"
                      />
                    )}
                  </div>
                  {OnProposalAcceptanceState.submissionFailed && (
                    <div className="errorMsg show text-center">
                      {OnProposalAcceptanceState.errorMsgOnAcceptingProposal}
                    </div>
                  )}
                </Container>
              </div>
              {globals.isBrandMX && (
                <TermsAndConditions
                  payFrequency={payFrequency}
                  nlFeePerAnnumIncGST={nlFeePerAnnumIncGST}
                  financierEstablishmentFee={financierEstablishmentFee}
                  fbtMethod={fbtMethod}
                  spFeePerAnnumIncGST={spFeePerAnnumIncGST}
                  showRecommendedRetailPrice={showRecommendedRetailPrice}
                  financierFeePerPay={financierFeePerPay}
                />
              )}
              {globals.isBrandRS && (
                <TermsAndConditionsRS
                  displayRetailPrice={showRecommendedRetailPrice}
                  isGov={isGov}
                  fbtMethod={fbtMethod}
                  payFrequency={payFrequency}
                  financierFeePerPay={financierFeePerPay}
                />
              )}
            </>
          )}
        </E.ProposalReviewPage>
      </Layout>

      {/* TODO(VJ): for testtt */}
      {displayCustomPdf && (
        <div id="pdf1">
          <PdfView
            dontScroll
            type={type}
            proposalEstimateId={proposalEstimateId}
            annualRate={annualRate}
            leaseTerm={leaseTerm}
            kmPerAnnum={kmPerAnnum}
            nlFeePerPay={nlFeePerPay}
            financeAmount={financeAmount}
            carRepaymentPerPayExGST={carRepaymentPerPayExGST}
            totalLeaseRunningCostsPerPayExGST={
              totalLeaseRunningCostsPerPayExGST
            }
            compInsuranceCommissionPerAnnumIncGST={
              compInsuranceCommissionPerAnnumIncGST
            }
            gapCoverCommissionPerAnnumIncGST={gapCoverCommissionPerAnnumIncGST}
            vehicleFBTValue={vehicleFBTValue}
            financierEstablishmentFeePerAnnum={
              financierEstablishmentFeePerAnnum
            }
            rpcCommissionPerAnnumIncGST={rpcCommissionPerAnnumIncGST}
            brokeragePerAnnum={brokeragePerAnnum}
            residualPCT={residualPCT}
            leaseResidualAmountIncGST={leaseResidualAmountIncGST}
            compInsuranceCommissionExGST={compInsuranceCommissionExGST}
            compInsuranceCommGST={compInsuranceCommGST}
            gapCoverCommissionExGST={gapCoverCommissionExGST}
            gapCoverCommGST={gapCoverCommGST}
            rpcCommissionExGST={rpcCommissionExGST}
            rpcCommGST={rpcCommGST}
            financierEstablishmentFee={financierEstablishmentFee}
            brokerage={brokerage}
            extendedWarrantyCommGST={extendedWarrantyCommGST}
            extendedWarrantyCommExGST={extendedWarrantyCommExGST}
            extendenWarrantyCommissionPerAnnumIncGST={
              extendenWarrantyCommissionPerAnnumIncGST
            }
            leaseProtectionCommissionPerAnnumIncGST={
              leaseProtectionCommissionPerAnnumIncGST
            }
            leaseProtectionCommExGST={leaseProtectionCommExGST}
            procurementFee={procurementFee}
            fbtMethod={fbtMethod}
            onProposalAcceptanceEvent={true}
            isExGST={null}
            evRebateApplicable={evRebateApplicable}
            evRebateValue = {evRebateValue}
            evRebateLink = {evRebateLink}
            monthlyRepaymentAmountIncGST={monthlyRepaymentAmountIncGST}
            retailPrice={retailPrice}
            priveawayPrice={priveawayPrice}
            financierFeePerPay={financierFeePerPay}
            nlFeePerAnnumIncGST={nlFeePerAnnumIncGST}
            spFeePerAnnumIncGST={spFeePerAnnumIncGST}
            specm={proposalEstimate && proposalEstimate.specm}
            preTaxPerPay={proposalEstimate && proposalEstimate.preTaxPerPay}
          />
        </div>
      )}
      {/* TODO(VJ): for testtt */}
    </>
  )
}

function mapStateToProps(
  state: {
    authentication: { isAuthenticated: boolean; opportunityId: string }
    individualEstimate: { estimate: any }
    consultant: { firstName: string }
    user: {
      employer: {
        payFrequency: string
        employerGRS: { 
          gstExclusiveDeductionsCode: string;
          evRebateApplicable: boolean;
          evRebateValue: number;
          evRebateLink: string;
        }
      }
      firstName?: string
    }
    applicationRoles: {}
    opportunity: { brand: string }
    proposal: any
  },
  ownProps: any
) {
  const { isAuthenticated, opportunityId } = state.authentication
  const estimate = state.individualEstimate.estimate
  const { firstName: consultantFirstName } = state.consultant
  const { firstName: userFirstName, employer: { payFrequency } = {} } =
    state.user
  const isExGST =
    state.user &&
    state.user.employer &&
    state.user.employer.employerGRS.gstExclusiveDeductionsCode === 'Yes'
  const applicationRole = state.applicationRoles
  const annualRate = estimate && estimate.annualRate
  const fbtMethod = estimate && estimate.fbtMethod
  const leaseTerm = estimate && estimate.leaseTerm
  const kmPerAnnum = estimate && estimate.kmPerAnnum
  const nlFeePerPay = estimate && (isExGST
    ? estimate.nlFeePerPayExGST
    : estimate.nlFeePerPayIncGST)
  const financeAmount = estimate && estimate.financeAmount
  const carRepaymentPerPayExGST = estimate && estimate.carRepaymentPerPayExGST
  const totalLeaseRunningCostsPerPayExGST = estimate && 
    estimate.totalLeaseRunningCostsPerPayExGST
  const compInsuranceCommissionPerAnnumIncGST = estimate && 
    estimate.compInsuranceCommissionPerAnnumIncGST
  const gapCoverCommissionPerAnnumIncGST = estimate && 
    estimate.gapCoverCommissionPerAnnumIncGST
  const vehicleFBTValue = estimate && estimate.vehicleFBTValue
  const financierEstablishmentFeePerAnnum = estimate && 
    estimate.financierEstablishmentFeePerAnnum
  const brokeragePerAnnum = estimate && estimate.brokeragePerAnnum
  const residualPCT = estimate && estimate.residualPCT
  const leaseResidualAmountIncGST = estimate && estimate.leaseResidualAmountIncGST
  const nlFeePerAnnumIncGST = estimate && (
    estimate.nlFeePerAnnumIncGST !== null ? estimate.nlFeePerAnnumIncGST : 275)
  const financierEstablishmentFee = estimate && (
    estimate.financierEstablishmentFee !== null
      ? estimate.financierEstablishmentFee
      : 431.82)
  const financierFeePerPay= estimate && estimate.financierFeePerPay
  const spFeePerAnnumIncGST = estimate && (
    estimate.spFeePerAnnumIncGST !== null ? estimate.spFeePerAnnumIncGST : 325)
  const retailPrice = estimate && estimate.retailPrice
  const priveawayPrice = estimate && estimate.priveawayPrice
  const extendedWarrantyCommGST = estimate && estimate.extendedWarrantyCommGST
  const extendedWarrantyCommExGST = estimate && estimate.extendedWarrantyCommExGST
  const extendenWarrantyCommissionPerAnnumIncGST = estimate && 
    estimate.extendenWarrantyCommissionPerAnnumIncGST
  const leaseProtectionCommissionPerAnnumIncGST = estimate && 
    estimate.leaseProtectionCommissionPerAnnumIncGST
  const leaseProtectionCommExGST = estimate && estimate.leaseProtectionCommExGST
  const monthlyRepaymentAmountIncGST = estimate && estimate.monthlyRepaymentAmountIncGST
  const procurementFee = estimate && 
    estimate.vehicle && estimate.vehicle.procurementFee
      ? estimate.vehicle.procurementFee
      : 0
  const rpcCommissionPerAnnumIncGST = estimate && estimate.rpcCommissionPerAnnumIncGST
  const rpcCommissionExGST = estimate && estimate.rpcCommissionExGST
  const rpcCommGST = estimate && estimate.rpcCommGST
  const brand = state.opportunity.brand
  const ctp = estimate && estimate.ctp
  const brokerage = estimate && estimate.brokerage
  const compInsuranceCommissionExGST = estimate && estimate.compInsuranceCommissionExGST
  const compInsuranceCommGST = estimate && 
     estimate.compInsuranceCommGST
  const gapCoverCommissionExGST = estimate && 
    estimate.gapCoverCommissionExGST
  const gapCoverCommGST = estimate && estimate.gapCoverCommGST
  const proposalEstimateId =
    state.proposal && state.proposal.proposal && state.proposal.proposal.quoteId
      ? state.proposal.proposal.quoteId
      : null
  const type = 'proposal'
  const evRebateApplicable = state.user.employer.employerGRS.evRebateApplicable
  const evRebateValue = state.user.employer.employerGRS.evRebateValue
  const evRebateLink = state.user.employer.employerGRS.evRebateLink
  const fuelPricePerLitre = estimate && estimate.fuelPricePerLitre
  const preTaxPerPay =  estimate && estimate.preTaxPerPay

  return {
    isAuthenticated,
    opportunityId,
    estimate,
    consultantFirstName,
    userFirstName,
    payFrequency,
    applicationRole,
    annualRate,
    fbtMethod,
    leaseTerm,
    kmPerAnnum,
    nlFeePerPay,
    financeAmount,
    carRepaymentPerPayExGST,
    totalLeaseRunningCostsPerPayExGST,
    compInsuranceCommissionPerAnnumIncGST,
    gapCoverCommissionPerAnnumIncGST,
    vehicleFBTValue,
    financierEstablishmentFeePerAnnum,
    brokeragePerAnnum,
    residualPCT,
    leaseResidualAmountIncGST,
    nlFeePerAnnumIncGST,
    financierEstablishmentFee,
    financierFeePerPay,
    spFeePerAnnumIncGST,
    retailPrice,
    priveawayPrice,
    extendedWarrantyCommGST,
    extendedWarrantyCommExGST,
    extendenWarrantyCommissionPerAnnumIncGST,
    leaseProtectionCommissionPerAnnumIncGST,
    leaseProtectionCommExGST,
    monthlyRepaymentAmountIncGST,
    procurementFee,
    rpcCommissionPerAnnumIncGST,
    rpcCommissionExGST,
    rpcCommGST,
    brand,
    ctp,
    brokerage,
    compInsuranceCommissionExGST,
    compInsuranceCommGST,
    gapCoverCommissionExGST,
    gapCoverCommGST,
    proposalEstimateId,
    type,
    evRebateApplicable,
    evRebateValue,
    evRebateLink,
    fuelPricePerLitre,
    isExGST,
    preTaxPerPay
  }
}

export default connect(mapStateToProps)(withLocation(ReviewProposal))
